<app-page-container>
    <div *ngIf="isSearchBarOn > 0" class="startpage-top-container"><span class="page-title"
            [innerHtml]="'searchInstitution' | translate"></span>
        <div class="extern-start-search">

            <dx-form class="extern-start-search-form" #externSearchForm [(formData)]="formData">
                <dxi-item itemType="group" colCount="3">

                    <dxi-item dataField="searchBetreuungsArt" editorType="dxSelectBox" min-width="100"
                        [label]="{ text: 'careType' | translate }"
                        [editorOptions]="{ tabIndex: 1, dataSource: configService.getKatalog('BetreuungsArtKatalog'), onValueChanged: onBetreuungsArtValueChanged, 
                        valueExpr: 'id', displayExpr: 'bezeichnung', searchMode: 'startswith', searchTimeout: 200, searchExpr: 'bezeichnung' , 
                        showClearButton: true }">
                    </dxi-item>

                    <dxi-item dataField="searchBetreuungsZeit" editorType="dxSelectBox" min-width="100"
                        [label]="{ text: 'careTime' | translate }"
                        [editorOptions]="{ tabIndex: 2, dataSource: betreuungsZeitDataSource, onValueChanged: onBetreuungsZeitValueChanged, valueExpr: 'id', displayExpr: 'bezeichnung', 
                        searchMode: 'startswith', searchTimeout: 200, searchExpr: 'bezeichnung' , showClearButton: true }">
                    </dxi-item>

                    <dxi-item dataField="meinStandort" [label]="{ text: 'myLocation' | translate }">
                        <div *dxTemplate="let data of 'autoCompleteTemplate'">
                            <app-autocompletebox-osm [placeholder]="'zipCityStreet' | translate"
                                [value]="formData.meinStandort" [centerLat]="addressLat" [centerLng]="addressLon"
                                (onSelected)="onSelected($event)"></app-autocompletebox-osm>
                        </div>
                    </dxi-item>

                </dxi-item>
            </dx-form>

            <dx-button tabindex="4" type="default" class="extern-start-search-btn" (onClick)="onSearchClick()"
                icon="find" [text]="'search' | translate">
            </dx-button>
        </div>
    </div>

    <div class="extern-start-info">
        <div class="startText" [innerHtml]='welcomeText'></div>
    </div>
</app-page-container>